import React from 'react';
import DesktopArrow from '../../../assets/images/DesktopArrow.svg';
import MobileArrow from '../../../assets/images/MobileArrow.svg';
import styles from './ErrorBox.module.scss';
import WarningIcon from '../../../assets/images/WarningIcon.svg';

function ErrorBox(props) {
  const { message } = props;
  return (
    <div className={styles.errorWrapper}>
      <div className={styles.desktopArrow}>
        <DesktopArrow />
      </div>
      <div className={styles.mobileArrow}>
        <MobileArrow />
      </div>
      <div className={styles.messageWrapper}>
        <div>
          <WarningIcon />
        </div>
        <div className={styles.message}>{message}</div>
      </div>
    </div>
  );
}

export default ErrorBox;
